import { create } from 'zustand';

export type ScoreUpProcedureState = {
  procedureCount: number;
  addProcedureCount: () => void;
};

export const useScoreUpProcedureState = create<ScoreUpProcedureState>((set) => ({
  procedureCount: 0,
  addProcedureCount: () => {
    set(({ procedureCount }) => ({
      procedureCount: procedureCount + 1,
    }));
  },
}));
